import dayjs from "dayjs";
import { ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { mdiCalendarQuestion } from "@mdi/js";

import AppBar from "components/AppBar";
import AsyncAvatar from "components/AsyncAvatar";
import DataIconPlaceholder from "components/DataIconPlaceholder";
import PageLayout from "components/PageLayout";
import combineObjectsByKey from "utils/combineObjectsByKey";
import getNameInitials from "utils/getNameInitials";
import { StorageBuckets } from "api/storage";
import { GetUserById } from "api/profile";
import { VoteByEventId } from "api/vote";
import compareString from "utils/compareString";
import useBoundStore from "store";
import VirtualizedList from "components/VirtualizedList";

export interface PendingProps {
  users: GetUserById[];
  votes: VoteByEventId[];
  onBack?: () => void;
}

function Pending(props: PendingProps) {
  const { users, votes, onBack } = props;
  const smallAvatars = useBoundStore((state) => state.miscellaneous.smallAvatars);
  const isMobileDevice = useBoundStore((state) => state.miscellaneous.isMobileDevice);

  // we must use combine because in the groups does not contain the names, avatars of the users
  const combined = (combineObjectsByKey(users, votes, "uid") as Array<Partial<VoteByEventId> & GetUserById>).sort(
    (a, b) => compareString(a.name ?? "", b.name ?? "")
  );

  /**
   * Generate items which will be used to display de virtualized list
   *
   * @returns
   */
  function generateVirtualizedList(): JSX.Element[] {
    const vrList: JSX.Element[] = [];

    combined.forEach((user) =>
      vrList.push(
        <ListItem>
          <ListItemAvatar>
            <AsyncAvatar
              avatarFile={user.avatar ? smallAvatars[user.avatar] : undefined}
              avatarName={user.avatar}
              placeholder={getNameInitials(user.name)}
              bucket={StorageBuckets.PROFILES_AVATARS}
            />
          </ListItemAvatar>
          <ListItemText
            key={user.name}
            primary={user.name}
            secondary={
              user.updated_at ? `Last seen on ${dayjs(user.updated_at).format("MMMM DD, HH:mm")}` : "Not seen event"
            }
          />
        </ListItem>
      )
    );

    return vrList;
  }

  return (
    <PageLayout appBar={<AppBar title='Pending' onBack={onBack} />} paddingBottom={false}>
      {combined.length ? (
        <VirtualizedList
          estimateSize={72}
          rows={generateVirtualizedList()}
          style={{ paddingTop: isMobileDevice ? 0 : "16px" }}
        />
      ) : (
        <DataIconPlaceholder text='All participants have joined this event' icon={mdiCalendarQuestion} />
      )}
    </PageLayout>
  );
}

export default Pending;
